<div class="flex flex-col gap-4">
  <!-- Tarjeta de códigos: cabecera con acciones + grilla de 2 columnas -->
  <div class="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
    <!--
      Cabecera que ENVUELVE: en 412px, Copiar y Descargar juntos no entran al
      lado del rótulo. Antes de envolver, el rótulo se comprimía hasta partirse
      letra por letra; ahora las acciones bajan a su propio renglón.
    -->
    <div
      class="flex flex-wrap items-center gap-2 gap-y-1.5 border-b border-gray-200 bg-slate-50 px-3 py-2 text-xs font-bold uppercase tracking-wider text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
    >
      <span>
        {{ 'mfa_setup_recovery_count' | transloco: { count: codes.length } }}
      </span>

      <span class="ml-auto flex gap-1.5">
        @if (canCopy) {
          <button
            type="button"
            data-test="mfa-copy"
            class="text-primary flex min-h-11 items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-sm font-semibold normal-case tracking-normal dark:bg-gray-700"
            (click)="copyCodes()"
          >
            <mat-icon
              class="icon-size-4"
              [svgIcon]="'heroicons_outline:clipboard'"
            ></mat-icon>
            {{
              (copied() ? 'mfa_setup_recovery_copied' : 'mfa_setup_recovery_copy')
                | transloco
            }}
          </button>
        }
        <button
          type="button"
          data-test="mfa-download"
          class="text-primary flex min-h-11 items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-sm font-semibold normal-case tracking-normal dark:bg-gray-700"
          (click)="downloadCodes()"
        >
          <mat-icon
            class="icon-size-4"
            [svgIcon]="'heroicons_outline:arrow-down-tray'"
          ></mat-icon>
          {{ 'mfa_setup_recovery_download' | transloco }}
        </button>
      </span>
    </div>

    <!--
      Una columna en teléfono: a dos columnas los códigos no entran y se parten
      a mitad de código. SIN scroll propio — el cuerpo del modal ya scrollea, y
      dos scrollers anidados en un teléfono es una trampa.
    -->
    <div
      class="grid grid-cols-1 gap-px bg-gray-100 sm:grid-cols-2 dark:bg-gray-700"
    >
      @for (code of codes; track code; let i = $index) {
        <span
          class="flex gap-2 bg-white px-3 py-2 font-mono text-md tracking-wider dark:bg-gray-900"
        >
          <i class="not-italic text-gray-300 dark:text-gray-600">{{ pad(i) }}</i>
          {{ code }}
        </span>
      }
    </div>
  </div>

  @if (copyFailed()) {
    <fuse-alert data-test="mfa-copy-error" [showIcon]="true" [type]="'error'">{{ 'mfa_setup_recovery_copy_error' | transloco }}</fuse-alert>
  }
  <fuse-alert [appearance]="'outline'" [showIcon]="true" [type]="'warning'">
    {{ 'mfa_setup_recovery_warning' | transloco }}
  </fuse-alert>

  <!-- Confirmación explícita: es el único paso que no se puede repetir -->
  <mat-checkbox
    data-test="mfa-ack"
    class="text-md"
    [color]="'primary'"
    (change)="acknowledged.emit($event.checked)"
  >
    {{ 'mfa_setup_recovery_ack' | transloco }}
  </mat-checkbox>
</div>
